<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="fecharModal" button-size="md" hide-footer title="Histórico Produto">
        <HistoricoSenadoList @fecharModal="fecharModal" :modal="true" :id="id"></HistoricoSenadoList>

    </b-modal>
</template>

<script>

import HistoricoSenadoList from '@/modules/patrimonio/historico-senado/HistoricoSenadoList.vue';

export default {
    name: "ModalHistoricoSenado",
    components: {
        HistoricoSenadoList
    },
    props: {
        id: Number,
    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal');
        },

    }
}

</script>

<style>
.images-container {
    display: flex;
    margin-left: 47%;

}
</style>
